/**
 * Dynamic Size Chart System
 * Handles size chart display based on product type and gender
 */

class SizeChart {
  constructor() {
    this.sizeChartData = {
      oversized: {
        unisex: {
          title: "Oversized (Unisex)",
          headers: ["Size", "Chest", "Length", "Shoulder", "Sleeve"],
          sizes: [
            ["XS", "42", "27.5", "20", "9.5"],
            ["S", "44", "28", "21", "10"],
            ["M", "46", "28.5", "22", "10.5"],
            ["L", "48", "29.5", "23", "11"],
            ["XL", "50", "30", "24", "11.5"],
            ["XXL", "52", "30.5", "25", "12"],
            ["XXXL", "54", "31", "26", "12.5"],
          ],
        },
      },
      polo: {
        male: {
          title: "Polo (Male)",
          headers: ["Size", "Chest", "Length", "Shoulder", "Sleeve"],
          sizes: [
            ["XS", "36", "25.5", "16", "7.5"],
            ["S", "38", "26.5", "17", "7.5"],
            ["M", "41", "27", "17.5", "8"],
            ["L", "44.5", "28", "18.5", "8.5"],
            ["XL", "48.5", "29.5", "19.5", "9"],
            ["XXL", "52.5", "31", "20.5", "9.5"],
            ["XXXL", "56", "32.5", "21.5", "10"],
          ],
        },
        // female: {
        //   title: "Polo (Female)",
        //   headers: [
        //     "Size",
        //     "Chest",
        //     "Length",
        //     "Shoulder",
        //     "Sleeve",
        //     "Bottom Opening",
        //   ],
        //   sizes: [
        //     ["XS", "31", "23.5", "13.5", "6", "33"],
        //     ["S", "33", "24", "14", "6", "35"],
        //     ["M", "35", "24.5", "15.5", "6.5", "37"],
        //     ["L", "38", "25", "16", "6.5", "40"],
        //     ["XL", "41", "25.5", "17", "7", "43"],
        //     ["XXL", "44", "26", "18", "7", "46"],
        //     ["XXXL", "47", "26.5", "19", "7.5", "49"],
        //   ],
        // },
      },
      "slim-fit-shirt": {
        male: {
          title: "Slim Fit Shirts (Male)",
          headers: [
            "Size",
            "Chest",
            "Waist",
            "Sleeves",
            "Shoulder",
            "Length",
            "Bottom",
          ],
          sizes: [
            ["36 (XS)", "38", "35", "23.5", "17", "28", "37"],
            ["38 (S)", "40", "37", "24", "17.75", "29.5", "39"],
            ["40 (M)", "42", "39", "24.5", "18.5", "30", "41"],
            ["42 (L)", "44", "41", "25", "19.25", "31", "43"],
            ["44 (XL)", "47", "44", "25.5", "20", "31.5", "46"],
            ["46 (XXL)", "49", "46", "26", "20.75", "32.5", "48"],
            ["48 (XXXL)", "52", "49", "27", "21.5", "33", "51"],
          ],
        },
        // female: {
        //   title: "Slim Fit Shirts (Female)",
        //   headers: [
        //     "Size",
        //     "Chest",
        //     "Waist",
        //     "Sleeves",
        //     "Shoulder",
        //     "Length",
        //     "Bottom",
        //   ],
        //   sizes: [
        //     ["36 (XS)", "34", "30", "20.5", "14.75", "24.5", "35"],
        //     ["38 (S)", "36", "32", "21.25", "15.25", "25", "37"],
        //     ["40 (M)", "38", "34", "22", "15.75", "25.5", "39"],
        //     ["42 (L)", "40", "36", "22.75", "16.25", "26", "41"],
        //     ["44 (XL)", "42", "38", "23.5", "16.75", "26.5", "43"],
        //     ["46 (XXL)", "44", "40", "24.25", "17.25", "27", "45"],
        //     ["48 (XXXL)", "47", "43", "25", "17.75", "28", "48"],
        //   ],
        // },
      },
      "regular-fit-shirt": {
        male: {
          title: "Regular Fit Shirts (Male)",
          headers: ["Size", "Chest", "Waist", "Sleeves", "Shoulder", "Length"],
          sizes: [
            ["36 (XS)", "40", "39", "24.5", "17.5", "30.5"],
            ["38 (S)", "42", "41", "25", "18", "31"],
            ["40 (M)", "44", "43", "25.5", "18.5", "31.5"],
            ["42 (L)", "46", "45", "26", "19.1", "32"],
            ["44 (XL)", "49", "48", "26.5", "19.7", "32.5"],
            ["46 (XXL)", "52", "51", "27", "20.3", "33"],
            ["48 (XXXL)", "56", "55", "27.5", "21", "33.5"],
          ],
        },
        // female: {
        //   title: "Regular Fit Shirts (Female)",
        //   headers: ["Size", "Chest", "Waist", "Sleeves", "Shoulder", "Length"],
        //   sizes: [
        //     ["36 (XS)", "38", "37", "21", "17", "25"],
        //     ["38 (S)", "40", "39", "22", "17.5", "25.5"],
        //     ["40 (M)", "42", "41", "23", "18", "26"],
        //     ["42 (L)", "44", "43", "24", "18.5", "26.5"],
        //     ["44 (XL)", "46", "45", "25", "19", "27"],
        //     ["46 (XXL)", "48", "47", "26", "19.5", "27.5"],
        //     ["48 (XXXL)", "50", "49", "27", "20", "28"],
        //   ],
        // },
      },
      "relaxed-fit-shirt": {
        male: {
          title: "Relaxed Fit Shirts (Male)",
          headers: ["Size", "Chest", "Waist", "Sleeves", "Shoulder", "Length"],
          sizes: [
            ["36 (XS)", "42", "42", "22.5", "17", "28"],
            ["38 (S)", "44", "44", "23", "17.75", "28.5"],
            ["40 (M)", "47", "47", "23", "18.5", "29"],
            ["42 (L)", "49", "49", "24", "19.25", "29.5"],
            ["44 (XL)", "52", "52", "25", "20", "30"],
            ["46 (XXL)", "55", "55", "26", "20.75", "31.5"],
            ["48 (XXXL)", "58", "58", "27", "21.5", "32.5"],
          ],
        },
        // female: {
        //   title: "Relaxed Shirts (Female)",
        //   headers: ["Size", "Chest", "Waist", "Sleeves", "Shoulder", "Length"],
        //   sizes: [
        //     ["36 (XS)", "41", "41", "23", "18.5", "26"],
        //     ["38 (S)", "43", "43", "24", "18.5", "27"],
        //     ["40 (M)", "45", "45", "25", "19.5", "28"],
        //     ["42 (L)", "48", "48", "26", "20.5", "29"],
        //     ["44 (XL)", "51", "51", "27", "21.5", "30"],
        //     ["46 (XXL)", "54", "54", "28", "22.5", "31"],
        //     ["48 (XXXL)", "57", "57", "29", "23.5", "32"],
        //   ],
        // },
      },
    };

    this.currentGender = "unisex"; // legacy, not used for tabs
    this.currentUnit = "inch";
    this.currentProductType = "";
    this.availableGenders = new Set(["unisex", "male"]); // Female options removed

    this.init();
  }

  init() {
    this.bindEvents();
    this.setupModal();
  }

  bindEvents() {
    // Unit tab switching
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("size-chart-tab")) {
        this.switchUnit(e.target.dataset.unit);
      }
    });

    // Product type selection
    const productTypeSelector = document.getElementById(
      "product-type-selector",
    );
    if (productTypeSelector) {
      productTypeSelector.addEventListener("change", (e) => {
        this.currentProductType = e.target.value;
        this.updateSizeChart();
      });
    }

    // Size chart modal opener
    document.addEventListener("click", (e) => {
      console.log("Click detected on:", e.target); // Debug log
      if (
        e.target.classList.contains("size-chart-opener") ||
        e.target.closest(".size-chart-opener")
      ) {
        e.preventDefault();
        e.stopPropagation();
        console.log("Size chart button clicked"); // Debug log
        this.openModal();
      }
    });

    // Close modal
    document.addEventListener("click", (e) => {
      if (
        e.target.id === "SizeChartModalClose" ||
        e.target.closest("#SizeChartModalClose")
      ) {
        this.closeModal();
      }
    });

    // Close modal on backdrop click
    document.addEventListener("click", (e) => {
      if (
        e.target.classList.contains("size-chart-modal__overlay") ||
        e.target.id === "SizeChartModal"
      ) {
        this.closeModal();
      }
    });

    // ESC key to close modal
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        document.getElementById("SizeChartModal").hasAttribute("open")
      ) {
        this.closeModal();
      }
    });
  }

  setupModal() {
    this.autoDetectProductType();
    this.updateAvailableGenders();
  }

  autoDetectProductType() {
    // Check if we can detect product type from current product
    if (typeof window.productData !== "undefined" && window.productData.tags) {
      const tags = window.productData.tags.map((tag) => tag.toLowerCase());

      console.log("Product tags:", tags); // Debug log

      if (tags.includes("oversized") || tags.includes("oversized-tshirt")) {
        this.currentProductType = "oversized";
        console.log("Detected product type: oversized"); // Debug log
      } else if (tags.includes("polo")) {
        this.currentProductType = "polo";
        console.log("Detected product type: polo"); // Debug log
      } else if (tags.includes("slim-fit") || tags.includes("slim")) {
        this.currentProductType = "slim-fit-shirt";
        console.log("Detected product type: slim-fit-shirt"); // Debug log
      } else if (tags.includes("regular-fit") || tags.includes("regular")) {
        this.currentProductType = "regular-fit-shirt";
        console.log("Detected product type: regular-fit-shirt"); // Debug log
      } else if (tags.includes("relaxed-fit") || tags.includes("relaxed")) {
        this.currentProductType = "relaxed-fit-shirt";
        console.log("Detected product type: relaxed-fit-shirt"); // Debug log
      }

      if (this.currentProductType) {
        const selector = document.getElementById("product-type-selector");
        if (selector) {
          selector.value = this.currentProductType;
        }
      }
    } else {
      console.log("No product data available or no tags found"); // Debug log
    }
  }

  deriveAvailableGendersForProduct(productTypeKey) {
    const genders = new Set();
    const productEntry = this.sizeChartData[productTypeKey];
    if (!productEntry) return genders;
    ["unisex", "male"].forEach((g) => {
      // Female removed
      if (productEntry[g]) genders.add(g);
    });
    return genders;
  }

  buildGenderTabs() {
    const tabsContainer = document.getElementById("size-chart-tabs");
    if (!tabsContainer) return;
    tabsContainer.innerHTML = "";
    // Unit tabs: Inch and CM
    ["inch", "cm"].forEach((unit) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = `size-chart-tab${
        unit === this.currentUnit ? " active" : ""
      }`;
      btn.dataset.unit = unit;
      btn.setAttribute("role", "tab");
      btn.setAttribute(
        "aria-selected",
        unit === this.currentUnit ? "true" : "false",
      );
      btn.textContent = unit.toUpperCase();
      tabsContainer.appendChild(btn);
    });
  }

  switchUnit(unit) {
    this.currentUnit = unit;
    this.updateAvailableGenders();
    this.updateSizeChart();
  }

  updateAvailableGenders() {
    this.buildGenderTabs();
  }

  updateSizeChart() {
    if (!this.currentProductType) {
      this.showLoading();
      return;
    }
    const productData = this.sizeChartData[this.currentProductType];
    if (!productData) {
      this.showError("Product type not found");
      return;
    }
    // Always use male as default for demo (can be improved for real gender logic)
    let genderData = productData.male || productData.unisex; // Female removed
    if (!genderData) {
      this.showError("Size chart not available for this combination");
      return;
    }
    // Convert to CM if needed
    let dataToRender = genderData;
    if (this.currentUnit === "cm") {
      dataToRender = this.convertToCm(genderData);
    }
    this.renderSizeChart(dataToRender);
  }
  // Converts inches to cm for all numeric values in the size chart
  convertToCm(data) {
    const cmData = JSON.parse(JSON.stringify(data)); // Deep copy
    // Conversion factor
    const factor = 2.54;
    // Convert headers if needed (leave as is for now)
    cmData.title = cmData.title.replace(
      /\(Male\)|\(Female\)|\(Unisex\)/,
      "(CM)",
    );
    cmData.headers = cmData.headers.map((h) => h);
    cmData.sizes = cmData.sizes.map((row) =>
      row.map((cell, idx) => {
        // Only convert if cell is a number (skip size name)
        if (idx === 0) return cell;
        const num = parseFloat(cell);
        if (isNaN(num)) return cell;
        return (num * factor).toFixed(1);
      }),
    );
    return cmData;
  }

  renderSizeChart(data) {
    const table = document.getElementById("size-chart-table");
    const header = document.getElementById("size-chart-header");
    const body = document.getElementById("size-chart-body");
    const loading = document.getElementById("size-chart-loading");

    // Hide loading and show table
    loading.style.display = "none";
    table.style.display = "table";

    // Show measurement images section
    this.showMeasurementImage();

    // Update title
    const title = document.querySelector(".size-chart-modal__title");
    if (title) {
      // Remove any bracketed unit from the title
      const cleanTitle = data.title.replace(/\s*\([^)]*\)/g, "");
      title.textContent = `Size Chart - ${cleanTitle}`;
    }

    // Build header
    header.innerHTML = "";
    const headerRow = document.createElement("tr");
    data.headers.forEach((headerText) => {
      const th = document.createElement("th");
      th.textContent = headerText;
      headerRow.appendChild(th);
    });
    header.appendChild(headerRow);

    // Build body
    body.innerHTML = "";
    data.sizes.forEach((sizeRow) => {
      const tr = document.createElement("tr");
      sizeRow.forEach((cellData, index) => {
        const td = document.createElement("td");
        td.textContent = cellData;
        if (index === 0) {
          td.classList.add("size-name");
        }
        tr.appendChild(td);
      });
      body.appendChild(tr);
    });
  }

  showLoading() {
    const table = document.getElementById("size-chart-table");
    const loading = document.getElementById("size-chart-loading");

    table.style.display = "none";
    loading.style.display = "block";
    loading.innerHTML = "<p>Select a product type to view size chart</p>";

    // Hide measurement images when showing loading
    this.hideMeasurementImages();
  }

  showError(message) {
    const table = document.getElementById("size-chart-table");
    const loading = document.getElementById("size-chart-loading");

    table.style.display = "none";
    loading.style.display = "block";
    loading.innerHTML = `<p class="error">${message}</p>`;

    // Hide measurement images when showing error
    this.hideMeasurementImages();
  }

  showMeasurementImage() {
    const imagesContainer = document.getElementById(
      "size-chart-measurement-images",
    );
    const tshirtImage = document.getElementById("tshirt-measurement");
    const shirtImage = document.getElementById("shirt-measurement");
    const poloImage = document.getElementById("polo-measurement");

    // Hide all images first
    tshirtImage.style.display = "none";
    shirtImage.style.display = "none";
    poloImage.style.display = "none";

    // Show the appropriate image based on product type
    switch (this.currentProductType) {
      case "oversized":
        tshirtImage.style.display = "block";
        break;
      case "polo":
        poloImage.style.display = "block";
        break;
      case "slim-fit-shirt":
      case "regular-fit-shirt":
      case "relaxed-fit-shirt":
        shirtImage.style.display = "block";
        break;
      default:
        // Default to t-shirt image
        tshirtImage.style.display = "block";
        break;
    }

    // Show the images container
    imagesContainer.style.display = "block";
  }

  hideMeasurementImages() {
    const imagesContainer = document.getElementById(
      "size-chart-measurement-images",
    );
    imagesContainer.style.display = "none";
  }

  openModal() {
    console.log("Opening size chart modal"); // Debug log
    const modal = document.getElementById("SizeChartModal");
    if (modal) {
      modal.setAttribute("open", "");
      modal.classList.add("show");
      modal.style.display = "flex";
      document.body.style.overflow = "hidden";

      // Update chart when opened
      this.updateSizeChart();
      console.log("Size chart modal opened successfully"); // Debug log
    } else {
      console.error("Size chart modal not found"); // Debug log
    }
  }

  closeModal() {
    const modal = document.getElementById("SizeChartModal");
    if (modal) {
      modal.removeAttribute("open");
      modal.classList.remove("show");
      modal.style.display = "none";
      document.body.style.overflow = "";
    }
  }
}

// Initialize size chart when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  console.log("Initializing size chart system"); // Debug log
  new SizeChart();
  console.log("Size chart system initialized"); // Debug log
});

// Export for potential external use
window.SizeChart = SizeChart;
